import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import AdminPageLayout from '../../layout/AdminPageLayout';
import AsideContentLayout from '../AsideContentLayout';
import AdminTaskForm from '../../forms/AdminContentForms/adminTask';
import { TASK_TYPES_LABELS } from '../../api/admin/types';
import ShareQR from '../../components/ShareQR';
const AdminTaskPageLayout = ({ formType, rallyId, taskId, taskInfo, }) => {
    const { t } = useTranslation();
    const taskTypes = [
        { uid: 'single-selection', title: t(TASK_TYPES_LABELS['single-selection']) },
        { uid: 'multiple-selection', title: t(TASK_TYPES_LABELS['multiple-selection']) },
        { uid: 'player-selection', title: t(TASK_TYPES_LABELS['player-selection']) },
        { uid: 'text', title: t(TASK_TYPES_LABELS['text']) },
        { uid: 'upload', title: t(TASK_TYPES_LABELS['upload']) },
        { uid: 'location', title: t(TASK_TYPES_LABELS['location']) },
        { uid: 'info', title: t(TASK_TYPES_LABELS['info']) },
        { uid: 'validated-text', title: t(TASK_TYPES_LABELS['validated-text']) },
    ];
    return (_jsx(AdminPageLayout, { logoutButton: true, children: _jsx("div", { className: 'page-content-wrapper admin-task-page', children: _jsx(AsideContentLayout, { mainContent: _jsx(AdminTaskForm, { formType: formType, taskTypes: taskTypes, rallyId: rallyId, taskId: taskId }), asideContent: formType === 'edit' && taskInfo?.status === 1 ? (_jsx(ShareQR, { url: `${location.origin}/admin/rallies/${rallyId}/task-preview/${taskInfo.sorting}`, description: "admin.share_task_description", title: "admin.share_task_title" })) : (_jsx(ShareQR, { alert: t('admin.generate_qr_code'), title: "admin.share_task_title" })) }) }) }));
};
export default AdminTaskPageLayout;
